import React, { Component } from 'react';
import { connect } from 'react-redux';
import HomeButton from './HomeButton';
import LogoutButton from './LogoutButton';
import { getInstructions } from '../../communication/CadessAPICommun';
import HelpButtonModal from '../modals/HelpButtonModal';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      html: null,
    };
  }

  componentWillMount() {
    const {
      user: {
        _id,
        role,
      },
    } = this.props;

    getInstructions(_id, role).then(data => {
      this.setState({ html: data });
    });
  }

  render() {
    return (
      <header className="header">
        <span className="brand-title">CADESS</span>
        <div className="header-btns">
          <HomeButton />
          <HelpButtonModal>
            <div dangerouslySetInnerHTML={{ __html: this.state.html }} />
          </HelpButtonModal>
          <LogoutButton />
        </div>
      </header>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { user } = auth;
  return {
    user,
  };
};

export default connect(mapStateToProps)(Header);

